import IsMacService from "@core-ui/ContextServices/IsMac";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import { useIsGesCloudMode } from "@ext/enterprise-cloud/utils/useIsGesCloudMode";

export const useHomeTitlebarOffset = () => {
	const { isTauri } = usePlatform();
	const isMac = IsMacService.value;
	const isGesCloudMode = useIsGesCloudMode();

	// Preserve the existing titlebar spacing of the regular desktop homepage.
	return isTauri && isMac && !isGesCloudMode ? "1rem" : "0rem";
};
